import React from 'react'
import {LandingPageNavbar, Footer} from "../component"

type LearningsProps = {}

const Learnings = (props: LearningsProps) => {
  return (
    <div>
        <LandingPageNavbar />
        Learnings
        <Footer />
    </div>
  )
}

export default Learnings